/**
 * Application Root
 *
 * Uses TanStack Router for routing.
 * All providers (Redux, Session, Theme) are in RootLayout.
 */

import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
